import { drawing as d, geometry as g } from '@progress/kendo-drawing';
import { Element } from './Element';
import { sizeOptionsOrDefault } from './utils';
import { HEIGHT, WIDTH, X, Y } from '../constants';
/**
 * Represents an Image element for displaying images in SVG.
 * Extends the Element class to provide image-specific functionality.
 */
export class Image extends Element {
    /**
     * Creates a new Image instance.
     * @param options - Configuration options for the image including source, position, and size
     */
    constructor(options) {
        super(options);
        this._initImage();
        this._initAccessibility();
    }
    /**
     * Redraws the image with updated options.
     * @param options - Updated configuration options
     */
    redraw(options) {
        if (options) {
            if (options.source) {
                this.drawingElement.src(options.source);
            }
            if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
                this.drawingElement.rect(this._rect());
            }
            super.redraw(options);
        }
    }
    /**
     * @hidden
     * Initializes the image drawing element.
     */
    _initImage() {
        const options = this.options;
        const rect = this._rect();
        this.drawingElement = new d.Image(options.source, rect);
        this.drawingElement.options.set('id', options.id);
    }
    /** @hidden */
    _rect() {
        const sizeOptions = sizeOptionsOrDefault(this.options);
        const origin = new g.Point(sizeOptions.x, sizeOptions.y);
        const size = new g.Size(sizeOptions.width, sizeOptions.height);
        return new g.Rect(origin, size);
    }
}
